import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SBCreditNoteDetailsPageActionButton from '../components/SBCreditNoteDetailsPageActionButton';
import SBCreditNoteForm from '../components/SBCreditNoteForm';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import PeppolResponseStatusCard from '../../common/PeppolResponseStatusCard';
import { useGetCreditNoteHandler } from '../../creditNotes/dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function SBCreditNoteDetailsPage() {
  useDocumentTitle('Self Billed Credit Note Details');
  const { document_id } = useParams();

  const { creditNote, isLoading } = useGetCreditNoteHandler(document_id);
  if (isLoading || !creditNote) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {creditNote && (
        <Box sx={{ pb: 4 }}>
          <TopBar title="Self Billed Credit Note Details" identifier={creditNote?.document_id}>
            <SBCreditNoteDetailsPageActionButton data={creditNote} />
          </TopBar>
        </Box>
      )}
      <IrbmStatusCard document={creditNote} />
      <PeppolResponseStatusCard document={creditNote} />
      <SBCreditNoteForm onSubmit={() => {}} onCancel={() => {}} initialData={creditNote} readOnly={true} />
    </Stack>
  );
}
